import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GetAuthStateUseCase } from '@auth';

/**
 * Guard that restricts access to super admin routes.
 * Redirects to /unauthorized if the user is not a super admin.
 */
export const superAdminGuard: CanActivateFn = () => {
  const authState = inject(GetAuthStateUseCase).execute();
  const router = inject(Router);

  if (!authState.user()?.isSuperAdmin) {
    router.navigate(['/unauthorized']);
    return false;
  }

  return true;
};
